import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Container, Flex, Heading } from '@radix-ui/themes';
import { Swiper, SwiperSlide } from 'swiper/react';

import { TopEmployer } from '../types/home-response';

import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';

import './top-employers.css';

import { Grid, Pagination, Autoplay } from 'swiper/modules';

const TopEmployersView = ({ topEmployers }: { topEmployers: TopEmployer[] }) => {
   console.log(topEmployers, 'EMPOLYTES');
   const { t } = useTranslation('global');
   return (
      <Container py="6">
         <Heading as="h3" align="center" className="subsecondblockHeading">
            {t('userpage.top')}
            <span className="textGradient">
               {' '}
               <span className="SubHaddingTxt">{t('userpage.employer')}</span>{' '}
            </span>
         </Heading>

         <Box
            className="employers-slider-container"
            pt="7"
            px="6"
            maxHeight={{
               initial: '260px',
               sm: '440px',
            }}
            height={{
               initial: '260px',
               sm: '440px',
            }}
         >
            <Swiper
               slidesPerView={2}
               grid={{
                  rows: 1,
                  fill: 'row',
               }}
               autoplay={{ delay: 3000, disableOnInteraction: false }}
               breakpoints={{
                  768: {
                     grid: {
                        rows: 2,
                        fill: 'row',
                     },
                     slidesPerView: 4,
                  },
               }}
               spaceBetween={8}
               pagination={{
                  clickable: true,
               }}
               modules={[Grid, Pagination, Autoplay]}
               className="employersSwiper"
            >
               {[...topEmployers].map((emp, idx) => {
                  return (
                     <SwiperSlide key={emp.id + idx}>
                        <Flex className="employer-slide-card" width="100px" height="100px">
                           <Link className="employer-link" to={`/company/${emp.employer_id}`}>
                              <img
                                 className="employer-slide-logo"
                                 loading="lazy"
                                 src={emp.company_logo}
                              />
                           </Link>
                        </Flex>
                     </SwiperSlide>
                  );
               })}
            </Swiper>
         </Box>
      </Container>
   );
};

export const TopEmployers = TopEmployersView;
